import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { BusinessService, OTPCreationRoute } from '@mpt-fo/common/core/services/business.service';
import { ProfileService } from '@mpt-fo/common/core/services/profile.service';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';
import { PasswordInput, PasswordValidatorType } from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import { ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';

@Component({
	selector: 'app-business-pin',
	templateUrl: './business-pin.component.html',
	styleUrls: ['./business-pin.component.scss'],
})
export class BusinessPinComponent implements OnInit {
	isMobile: any = false;
	pin: PasswordInput;
	confirmPin: PasswordInput;
	password: PasswordInput;
	fb: FormBuilder;
	form: FormGroup;
	router: Router;
	businessService: BusinessService;
	profileService: ProfileService;
	readonly PIN_LENGTH = 4;
	submitting = false;
	runningModal: NzModalRef;
	modalService: ModalService;
	showConfirmPinError: boolean;

	constructor(
		private screenManagerService: ScreenManagerService,
		fb: FormBuilder,
		router: Router,
		businessService: BusinessService,
		profileService: ProfileService,
		modalService: ModalService
	) {
		this.screenManagerService = screenManagerService;
		this.fb = fb;
		this.router = router;
		this.businessService = businessService;
		this.profileService = profileService;
		this.modalService = modalService;
	}

	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe((isMobile) => {
			this.isMobile = isMobile;
		});
	}

	initialize() {
		const otpFormData = this.businessService.getData();
		this.pin = new PasswordInput(otpFormData.newPin || '', 'Enter Pin', true, PasswordValidatorType.PIN, this.PIN_LENGTH);
		this.confirmPin = new PasswordInput(otpFormData.newPin || '', 'Confirm Pin', true, PasswordValidatorType.PIN, this.PIN_LENGTH);
		this.password = new PasswordInput(otpFormData.password || '', 'Password', true, PasswordValidatorType.BASIC);
		this.pin.setCanShowError(false);
		this.createForm();
	}

	createForm() {
		this.form = this.fb.group({
			pin: this.pin.getFormGroupControl(),
			confirmPin: this.confirmPin.getFormGroupControl(),
			password: this.password.getFormGroupControl(),
		});
		this.form.controls.confirmPin.valueChanges.subscribe((data) => {
			const validPin = StringHelper.validPin(data);
			if (validPin) {
				this.validatePin(PinCreation.PIN, data);
			} else {
				this.showConfirmPinError = false;
			}
		});
		this.form.controls.pin.valueChanges.subscribe((data) => {
			const validPin = StringHelper.validPin(data);
			if (validPin) {
				this.validatePin(PinCreation.CONFIRM_PIN, data);
			} else {
				this.showConfirmPinError = false;
			}
		});
	}

	submit() {
		if (this.submitting) {
			return;
		}
		this.submitting = true;
		const otpFormData = this.businessService.getData();
		otpFormData.newPin = this.form.value.confirmPin;
		otpFormData.password = this.form.value.password;
		this.businessService.saveData(otpFormData);
		const kycRoute: OTPCreationRoute = {
			key: 'PIN_CREATION',
			route: 'pin/business-pin',
			completed: true,
		};
		this.businessService.updateKycRoute(kycRoute);
		this.businessService.navigateKYCForm();
		this.submitting = false;
	}

	goBack() {
		const routes = this.businessService.getKycRoutes();
		const currentRoute = this.businessService.getData();
		const route = routes.find((x) => x.route === currentRoute?.currentRoute?.previousUrl);
		if (route) {
			route.completed = false;
			this.businessService.navigateKYCForm(route);
		} else {
			this.businessService.resetRoute();
			this.router.navigateByUrl('user/selection-mode');
		}
	}

	validatePin(key, confirmPin) {
		const form = this.form?.value;
		this.showConfirmPinError = form?.[key] !== confirmPin;
	}
}

enum PinCreation {
	PIN = 'pin',
	CONFIRM_PIN = 'confirmPin',
}
